// extracted by mini-css-extract-plugin
export default {"IconButton":"IconButton_IconButton__82U5E","default":"IconButton_default__3w7Pg"};